module.exports = __webpack_public_path__ + "static/media/400026_01.1b49997c.png";